var $2569ca3917233115$exports = {};
$2569ca3917233115$exports = {
    "breadcrumbs": `Morzsamen\xfc`
};


export {$2569ca3917233115$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
